import { render, staticRenderFns } from "./decorationManage.vue?vue&type=template&id=2354abe4&scoped=true"
import script from "./decorationManage.vue?vue&type=script&lang=js"
export * from "./decorationManage.vue?vue&type=script&lang=js"
import style0 from "./decorationManage.vue?vue&type=style&index=0&id=2354abe4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354abe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2354abe4')) {
      api.createRecord('2354abe4', component.options)
    } else {
      api.reload('2354abe4', component.options)
    }
    module.hot.accept("./decorationManage.vue?vue&type=template&id=2354abe4&scoped=true", function () {
      api.rerender('2354abe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/companyapp/modules/decorationManage.vue"
export default component.exports